import { Controller } from '@hotwired/stimulus'

// Reveals a dependent field when the option that needs it is picked. Generic on
// purpose: a trigger declares that it reveals (data-conditional-field-reveal),
// the panel only listens — so the next conditional field needs no new controller.
export default class extends Controller {
  static targets = ['panel']

  connect () {
    this.toggle()
  }

  toggle () {
    const checked = this.element.querySelector('input[type="radio"]:checked')
    const reveal = checked !== null && checked.dataset.conditionalFieldReveal === 'true'

    this.panelTargets.forEach((panel) => panel.classList.toggle('d-none', !reveal))
  }
}
